import Vue from 'vue'

const state = {
  envio: [],
  envios: [],
  envioEditar: [],
  envioVisualizar: [],
  link: []

}

const getters = {
  getEnvio: state => {
    return state.envio
  }
}

const mutations = {
  setEnvio (state, data) {
    state.envio = data
  },
  setEnvios (state, data) {
    state.envios = data
  },
  setLink (state, data) {
    state.link = data
  }
}

const actions = {
  getEnvios (context, config) {
    if (!config.ip) {
      config.ip = ''
    }

    if (!config.filter) {
      config.filter = ''
    }

    if (!config.data) {
      config.data = ''
    }

    if (!config.situacao) {
      config.situacao = ''
    }

    Vue.http.get('api/envios?id=' + config.id + '&filter=' + config.filter + '&data=' + config.data + '&situacao=' + config.situacao).then(response => {
      context.commit('setEnvios', response.body.data.data)
    })
  },
  getEnvio (context, id) {
    Vue.http.get('api/envio/' + id).then(response => {
      context.commit('setEnvio', response.data.data[0])
    })
  },
  getLink (context) {
    Vue.http.get('api/envio/link/gerarLink').then(response => {
      context.commit('setLink', response.data.data[0])
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/envio.js